import React, { useContext } from 'react';
import { TranslatorContext } from '@jutro/locale';

import { BreakpointTrackerContext } from '@jutro/layout';
import { Link } from '@jutro/components';
import messages from './SgRenewalSpmUpgradeTable.messages';

function SgRenewalSpmUpgradeTable(props) {
    const {
        showTermsAndConditions
    } = props;

    const translator = useContext(TranslatorContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const isMobile = breakpoint === 'phoneWide' || breakpoint === 'phone';

    return (
        <>
            {!isMobile
            && (
                <table className="sgCoverComparisonTable">
                    <thead>
                        <tr>
                            <th width="60%">{translator(messages.CoverAndBenefits)}</th>
                            <th width="20%">
                                {translator(messages.SagaSelect)}
                                <br />
                                {translator(messages.YourExistingCover)}
                            </th>
                            <th width="20%">{translator(messages.SagaPlus)}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <strong>{translator(messages.ThreeYearsFixedPrice)}</strong>
                                <ul>
                                    <li>{translator(messages.Bullet1)}</li>
                                    <li>{translator(messages.Bullet2)}</li>
                                </ul>
                                <Link href="/" onClick={showTermsAndConditions}>
                                    {translator(messages.TCApply)}
                                </Link>
                            </td>
                            <td><div className="cross"><span>{translator(messages.No)}</span></div></td>
                            <td><div className="tick"><span>{translator(messages.Yes)}</span></div></td>
                        </tr>

                        <tr>
                            <td>
                                <strong>{translator(messages.UninsuredDriverCover)}</strong>
                                {translator(messages.UninsuredDriverInfo)}
                            </td>
                            <td><div className="tick"><span>{translator(messages.Yes)}</span></div></td>
                            <td><div className="tick"><span>{translator(messages.Yes)}</span></div></td>
                        </tr>

                        <tr>
                            <td className="text-content">
                                <strong>{translator(messages.LegalProtection)}</strong>
                                {translator(messages.LegalProtectionInfo)}
                            </td>
                            <td><strong>{translator(messages.Optional)}</strong></td>
                            <td><div className="tick"><span>{translator(messages.Yes)}</span></div></td>
                        </tr>

                        <tr>
                            <td className="text-content">
                                <strong>{translator(messages.KeyProtection)}</strong>
                                {translator(messages.KeyProtectionInfo)}
                            </td>
                            <td><strong>{translator(messages.Optional)}</strong></td>
                            <td><div className="tick"><span>{translator(messages.Yes)}</span></div></td>
                        </tr>

                        <tr>
                            <td className="text-content">
                                <strong>{translator(messages.OnwardTaxiTravel)}</strong>
                                {translator(messages.OnwardTaxiTravelInfo)}
                            </td>
                            <td><div className="cross"><span>{translator(messages.No)}</span></div></td>
                            <td><div className="tick"><span>{translator(messages.Yes)}</span></div></td>
                        </tr>

                        <tr>
                            <td className="text-content">
                                <strong>{translator(messages.AccidentHealthcareCover)}</strong>
                                {translator(messages.AccidentHealthcareCoverInfo)}
                            </td>
                            <td><div className="cross"><span>{translator(messages.No)}</span></div></td>
                            <td><div className="tick"><span>{translator(messages.Yes)}</span></div></td>
                        </tr>

                        <tr>
                            <td className="text-content">
                                <strong>{translator(messages.ProtectedNoClaimDiscount)}</strong>
                                {translator(messages.ProtectedNoClaimDiscountInfo)}
                            </td>
                            <td><div className="tick"><span>{translator(messages.Yes)}</span></div></td>
                            <td><div className="tick"><span>{translator(messages.Yes)}</span></div></td>
                        </tr>

                        <tr>
                            <td className="text-content">
                                <strong>{translator(messages.ClaimsPromise)}</strong>
                                {translator(messages.ClaimsPromiseInfo)}
                            </td>
                            <td><div className="cross"><span>{translator(messages.No)}</span></div></td>
                            <td><div className="tick"><span>{translator(messages.Yes)}</span></div></td>
                        </tr>
                    </tbody>
                </table>
            )
            }
            {isMobile
            && (
                <table className="sgCoverComparisonTable sgCoverComparisonTableMobile">
                    <thead>
                        <tr>
                            <th width="50%">
                                {translator(messages.SagaSelect)}
                                <br />
                                {translator(messages.YourExistingCover)}
                            </th>
                            <th width="50%">{translator(messages.SagaPlus)}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td colSpan="2" className="sgComparisonTableMobileInfoContainer">
                                <strong>{translator(messages.ThreeYearsFixedPrice)}</strong>
                                <ul>
                                    <li>{translator(messages.Bullet1)}</li>
                                    <li>{translator(messages.Bullet2)}</li>
                                </ul>
                                <Link href="/" onClick={showTermsAndConditions}>
                                    {translator(messages.TCApply)}
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td><div className="cross"><span>{translator(messages.No)}</span></div></td>
                            <td><div className="tick"><span>{translator(messages.Yes)}</span></div></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="sgComparisonTableMobileInfoContainer">
                                <strong>{translator(messages.UninsuredDriverCover)}</strong>
                                {translator(messages.UninsuredDriverInfo)}
                            </td>
                        </tr>
                        <tr>
                            <td><div className="tick"><span>{translator(messages.Yes)}</span></div></td>
                            <td><div className="tick"><span>{translator(messages.Yes)}</span></div></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="sgComparisonTableMobileInfoContainer">
                                <strong>{translator(messages.LegalProtection)}</strong>
                                {translator(messages.LegalProtectionInfo)}
                            </td>
                        </tr>
                        <tr>
                            <td><strong>{translator(messages.Optional)}</strong></td>
                            <td><div className="tick"><span>{translator(messages.Yes)}</span></div></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="sgComparisonTableMobileInfoContainer">
                                <strong>{translator(messages.KeyProtection)}</strong>
                                {translator(messages.KeyProtectionInfo)}
                            </td>
                        </tr>
                        <tr>
                            <td><strong>{translator(messages.Optional)}</strong></td>
                            <td><div className="tick"><span>{translator(messages.Yes)}</span></div></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="sgComparisonTableMobileInfoContainer">
                                <strong>{translator(messages.OnwardTaxiTravel)}</strong>
                                {translator(messages.OnwardTaxiTravelInfo)}
                            </td>
                        </tr>
                        <tr>
                            <td><div className="cross"><span>{translator(messages.No)}</span></div></td>
                            <td><div className="tick"><span>{translator(messages.Yes)}</span></div></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="sgComparisonTableMobileInfoContainer">
                                <strong>{translator(messages.AccidentHealthcareCover)}</strong>
                                {translator(messages.AccidentHealthcareCoverInfo)}
                            </td>
                        </tr>
                        <tr>
                            <td><div className="cross"><span>{translator(messages.No)}</span></div></td>
                            <td><div className="tick"><span>{translator(messages.Yes)}</span></div></td>
                        </tr>

                        <tr>
                            <td colSpan="2" className="sgComparisonTableMobileInfoContainer">
                                <strong>{translator(messages.ProtectedNoClaimDiscount)}</strong>
                                {translator(messages.ProtectedNoClaimDiscountInfo)}
                            </td>
                        </tr>
                        <tr>
                            <td><div className="tick"><span>{translator(messages.Yes)}</span></div></td>
                            <td><div className="tick"><span>{translator(messages.Yes)}</span></div></td>
                        </tr>
                    </tbody>
                </table>
            )
            }
        </>
    );
}

export default SgRenewalSpmUpgradeTable;
